module.exports = __webpack_public_path__ + "img/marginacion-tm.040c3fbd.jpg";